import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import CreativeAgentPage from './pages/CreativeAgentPage';
import PrototypeCreativeAgent from './pages/PrototypeCreativeAgent';
import PrototypeAgentStatusPage from './pages/PrototypeAgentStatusPage';
import PrototypeCanvasPage from './pages/PrototypeCanvasPage';
import PrototypeWritingPage from './pages/PrototypeWritingPage';
import ScriptDetail from './pages/ScriptDetail';
import AgentLab from './pages/AgentLab';
import CanvasPage from './pages/CanvasPage';
import CanvasListPage from './pages/CanvasListPage';
import AssetManagerPage from './pages/AssetManagerPage';
import Admin from './pages/Admin';
import Profile from './pages/Profile';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';
import useTheme from './hooks/useTheme';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

export default function App() {
  useTheme();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/prototype/canvas" element={<PrototypeCanvasPage />} />
        <Route path="/prototype/agent-status" element={<PrototypeAgentStatusPage />} />
        <Route path="/writing-preview" element={<PrototypeWritingPage />} />
        <Route path="/login"    element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Navigate to="/home" />} />
          <Route path="home"        element={<Home />} />
          <Route path="studio"      element={<Navigate to="/home" replace />} />
          <Route path="creative-agent" element={<CreativeAgentPage />} />
          <Route path="prototype/creative-agent" element={<PrototypeCreativeAgent />} />
          <Route path="prototype/agent-status" element={<PrototypeAgentStatusPage />} />
          <Route path="prototype/canvas" element={<PrototypeCanvasPage />} />
          <Route path="director"    element={<Navigate to="/writing" replace />} />
          <Route path="writing"     element={<AgentLab />} />
          {/* 「剧本管理」整页已砍：审核评分并入写剧本 tab，旧全部剧本/上传新建/版本记录下线 */}
          <Route path="script-manager" element={<Navigate to="/writing" replace />} />
          <Route path="library"     element={<Navigate to="/writing" replace />} />
          <Route path="scripts"     element={<Navigate to="/writing" replace />} />
          <Route path="scripts/:id" element={<ScriptDetail />} />
          <Route path="assets"      element={<AssetManagerPage />} />
          <Route path="image"       element={<Navigate to="/assets" replace />} />
          <Route path="agent-lab"   element={<Navigate to="/writing" replace />} />
          <Route path="video"       element={<Navigate to="/assets?tab=videos" replace />} />
          <Route path="canvas"       element={<CanvasListPage />} />
          <Route path="canvas/:id"  element={<CanvasPage />} />
          <Route path="deliveries"  element={<Navigate to="/assets?tab=delivery" replace />} />
          <Route path="review"      element={<Navigate to="/writing?tab=review" replace />} />
          <Route path="profile"     element={<Profile />} />
        </Route>
        <Route path="/admin" element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
          <Route index element={<Admin />} />
        </Route>
        <Route path="/prototype/admin" element={<AdminLayout preview />}>
          <Route index element={<Admin preview />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
